import React from "react";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Tooltip } from "@mui/material";

const OutstandingPayment = () => {
  return (
    <Tooltip title="Payment Outstanding">
      <span
        role="img"
        aria-label="Payment Outstanding"
        className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-amber-500/15 text-amber-700 dark:text-amber-300"
      >
        <AttachMoneyIcon fontSize="small" />
      </span>
    </Tooltip>
  );
};

export default OutstandingPayment;
